"use client"

import { PropsWithChildren } from "react"
import { usePurchaseSubscriptionUrl } from "@/api/subscription"
import { Button } from "@/components/ui/button"
import { SubscriptionPlan } from "@/types/subscription"

export type PurchaseSubscriptionButtonProps = {
  teamId: string
  teamSlug: string
  plan: SubscriptionPlan
  successUrl: string
  className?: string
}

export const PurchaseSubscriptionButton = ({
  teamId,
  teamSlug,
  plan,
  successUrl,
  children,
  className,
}: PropsWithChildren<PurchaseSubscriptionButtonProps>) => {
  const purchaseUrl = usePurchaseSubscriptionUrl({ teamId, teamSlug, successUrl })

  const handlePurchase = () =>
    purchaseUrl.mutate(plan, {
      onSuccess: ({ url }) => (window.location.href = url),
    })

  return (
    <Button
      variant="default"
      type="button"
      disabled={purchaseUrl.isPending}
      onClick={handlePurchase}
      className={className}
    >
      {children}
    </Button>
  )
}
